import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed } from 'vue';
import { getCustomerTypeList, addCustomerTypes } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage } from 'element-plus';
export default {
  name: 'SelectCustomerTypeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const typeKeyWord = ref('');
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '客户类型名称',
        field: 'dictitemName',
        overflow: true
      }],
      pagerConfig: {
        pageSize: 5
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getCustomerTypeList({
              page: page.currentPage,
              rows: page.pageSize,
              keyWord: typeKeyWord.value
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      visible.value = false;
      emit('success', selectRows); // addCustomerTypes({
      //   custTypeCodes: selectRows.map((item) => item.dictitemCode).join(','),
      //   activityId: props.id,
      //   moduleType: 20,
      //   readFromBackup: 1,
      //   __warn: true,
      //   __repeat: true
      // }).then((data) => {
      //   if (data.success) {
      //     visible.value = false;
      //     emit('success', selectRows);
      //   }
      // });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择客户类型",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "600px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: typeKeyWord.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => typeKeyWord.value = $event),
              placeholder: "类型名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};